var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('entity-section',{attrs:{"entity":_vm.entity,"pending":_vm.pending}}),_c('agreements-section',{attrs:{"agreements":_vm.agreements},on:{"setAgreementsPage":_vm.getAgreements}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }